let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2QSk7")).then(() => parcelRequire('i2c2s'));